import { UsersApiHelper } from "api/ApiHelper";
import { reverseBaseAcresImportTransformsForExport } from "./baseAcresExportReverseTransforms";
import { coalesceBaseAcresExportSharePercent } from "./helpers";
import { TEMPLATE_URL_PATH } from "components/Financial/FinancialHelpers";
import ExcelJS from "exceljs";
import fileDownload from "js-file-download";

export const TEMPLATE_FILE_NAME = "Base Acres - Template.xlsx";
export const SHEET_NAME_EXPECTED = "Base Acres";
export const SHARE_PERCENT_KEYS = [];

export async function exportBaseAcresWorkbook(globalState, crop_year, enqueueSnackbar) {
  const urlResponse = await UsersApiHelper.getPublicDocument(
    { document_path: TEMPLATE_URL_PATH, document_name: TEMPLATE_FILE_NAME },
    globalState
  );

  const templateUrl = urlResponse?.url;
  if (!templateUrl) {
    throw new Error("Could not retrieve template URL.");
  }

  const templateResponse = await fetch(templateUrl);
  if (!templateResponse.ok) {
    throw new Error(`Template download failed: ${templateResponse.status}`);
  }
  const arrayBuffer = await templateResponse.arrayBuffer();

  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(arrayBuffer);

  const sheet = workbook.worksheets[0];
  if (!sheet) {
    throw new Error("Template workbook has no worksheets.");
  }
  if (sheet.name !== SHEET_NAME_EXPECTED) {
    console.warn(`Expected sheet name "${SHEET_NAME_EXPECTED}", got "${sheet.name}"`);
  }

  const headerRow = sheet.getRow(1);
  const colMap = {};
  headerRow.eachCell({ includeEmpty: false }, (cell, colNumber) => {
    const key = cell.value;
    if (key) colMap[key] = colNumber;
  });

  const lastRow = sheet.rowCount;
  for (let r = lastRow; r >= 3; r--) {
    sheet.spliceRows(r, 1);
  }

  const cropsRaw =
    (await UsersApiHelper.selectProducerFarmFieldCrops(
      { producer_token: globalState.producer_token, crop_year, is_active: true },
      globalState
    )) ?? [];

  if (!cropsRaw.length) {
    enqueueSnackbar?.("No base acres found for the selected year — nothing to export.", { variant: "warning" });
    return;
  }

  const crops = coalesceBaseAcresExportSharePercent(cropsRaw.map((r) => ({ ...r })));

  crops.forEach((crop) => {
    const reversed = reverseBaseAcresImportTransformsForExport(crop);
    const rowData = {};
    Object.entries(colMap).forEach(([key]) => {
      rowData[key] = key === "crop_year" ? crop_year : (reversed[key] ?? null);
    });

    const newRow = sheet.addRow([]);
    Object.entries(colMap).forEach(([key, colNum]) => {
      const cell = newRow.getCell(colNum);
      cell.value = rowData[key] ?? null;
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  fileDownload(buffer, `Base-Acres-Export-${crop_year}.xlsx`);
}
